import { styled, Box, css } from '@mui/material';

const Container = styled(Box)({
  backgroundColor: '#efefef',
  top: 'var(--header-height)',
  left: 0,
  height: 'calc(100vh - var(--header-height))',
  width: '100%',
  padding: '1rem 1.5rem',
});

const AnnouncementList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  '& > *': {
    borderBottom: '0.05rem solid #6b6b6b',
  },
});

const globalStyles = css`
  html,
  body {
    font-size: 4vw;
    @media (orientation: landscape) {
      font-size: 2vw;
    }
  }
  .ant-image-preview-mask {
    background: black;
  }
  .ant-image-preview-operations {
    background: rgba(0, 0, 0, 0.5);
    & > *:not(:first-of-type, :nth-of-type(2)) {
      display: none;
    }
  }
  .ant-image-preview-operations-progress {
    top: 1rem;
  }
  .anticon-close {
    & > svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

const DownloadFile = styled('a')`
  display: inline-block;
  margin-top: 0.5rem;
  font-size: 1rem;
  width: fit-content;
  border: 0.1rem solid #0063a0;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  &,
  &:visited,
  &:link {
    color: #0063a0;
    text-decoration: none;
  }
  &:active {
    background-color: #0063a0;
    color: #fff;
  }
`;

export { Container, AnnouncementList, globalStyles, DownloadFile };
